import React, { useEffect, useState } from "react";
import {
  getApprovalStats,
  getApprovals,
  decideApproval,
  bulkApprove,
  autoApproveLowRisk,
} from "../../adminAPI/adminApprovalsApi";
import Pagination from "../../components/common/Pagination";
import { formatRelativeDate } from "../../utils/dateUtils";
import { getPriorityBadgeClass, getStatusBadgeClass } from "../../utils/badgeUtils";


const ApprovalsKYC = () => {
  const token = localStorage.getItem("otoken");

  /* ================= STATE ================= */
  const [stats, setStats] = useState({});
  const [approvals, setApprovals] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selected, setSelected] = useState([]);

   const [filters, setFilters] = useState({
    search: "",
    type: "",
    priority: "",
    status: "",
    age: "",
  });

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const PAGE_SIZE = 10;

  /* ================= LOADERS ================= */
  const loadStats = async () => {
    const data = await getApprovalStats(token);
    setStats(data);
  };

  const loadApprovals = async () => {
    const data = await getApprovals(
      { ...filters, page, limit: PAGE_SIZE },
      token
    );
    setApprovals(data.rows);
    setTotal(data.total);
  };

  useEffect(() => {
    loadStats();
    loadApprovals();
  }, [filters, page]);

  const handleFilterChange = (e) => {
    setFilters(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
    setPage(1);
  };


  /* ================= ACTIONS ================= Actions (Approve / Reject / Bulk / Auto)*/

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleDecision = async (id, status) => {
    await decideApproval(id, status, token);
    loadApprovals();
    loadStats();
  };

  const handleBulkApprove = async () => {
    if (!selectedIds.length) return;
    await bulkApprove(selectedIds, token);
    setSelectedIds([]);
    loadApprovals();
    loadStats();
  };

  const handleAutoApprove = async () => {
    await autoApproveLowRisk(token);
    loadApprovals();
    loadStats();
  };

  /* ================= UI ================= */
  return (
    <>
     
        <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>Reports & Complaints</h2>
            <div className="btn-group">
                <button className="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#exportModal">
                    <i className="bi bi-download"></i> Export
                </button>
                <button className="btn btn-success"><i className="bi bi-plus-lg"></i> New Report</button>
            </div>
        </div>

        {/* <!-- Stats Cards --> */}
        <div className="row mb-4">
            <div className="col-md-3">
                <div className="card bg-primary text-white">
                    <div className="card-body">
                        <h5>Total Reports</h5>
                        <h2 className="display-6">1,247</h2>
                        <small className="text-white-50"><i className="bi bi-arrow-up"></i> +12% this week</small>
                    </div>
                </div>
            </div>
            <div className="col-md-3">
                <div className="card bg-warning text-dark">
                    <div className="card-body">
                        <h5>Open Complaints</h5>
                        <h2 className="display-6">89</h2>
                        <small><i className="bi bi-arrow-down"></i> -5% this week</small>
                    </div>
                </div>
            </div>
            <div className="col-md-3">
                <div className="card bg-danger text-white">
                    <div className="card-body">
                        <h5>Critical Issues</h5>
                        <h2 className="display-6">23</h2>
                        <small className="text-white-50"><i className="bi bi-exclamation-triangle"></i> Needs attention</small>
                    </div>
                </div>
            </div>
            <div className="col-md-3">
                <div className="card bg-success text-white">
                    <div className="card-body">
                        <h5>Resolved</h5>
                        <h2 className="display-6">1,135</h2>
                        <small className="text-white-50"><i className="bi bi-check-circle"></i> 91% resolution</small>
                    </div>
                </div>
            </div>
        </div>

        {/* <!-- Tabs --> */}
        <ul className="nav nav-tabs mb-4" id="reportTabs" role="tablist">
            <li className="nav-item" role="presentation">
                <button className="nav-link active" id="reports-tab" data-bs-toggle="tab" data-bs-target="#reports" type="button">Reports</button>
            </li>
            <li className="nav-item" role="presentation">
                <button className="nav-link" id="complaints-tab" data-bs-toggle="tab" data-bs-target="#complaints" type="button">Complaints</button>
            </li>
        </ul>

        <div className="tab-content" id="reportTabsContent">
            {/* <!-- Reports Tab --> */}
            <div className="tab-pane fade show active" id="reports" role="tabpanel">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="mb-0"><i className="bi bi-file-earmark-text"></i> All Reports</h6>
                        <div>
                            <select className="form-select form-select-sm d-inline-block w-auto">
                                <option>Filter Status</option>
                                <option>New</option>
                                <option>Reviewed</option>
                                <option>Resolved</option>
                            </select>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table id="reportsTable" className="table table-hover mb-0">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>Reported By</th>
                                        <th>Target</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>#REP001</td>
                                        <td>john.doe@email.com</td>
                                        <td>Job Post #456</td>
                                        <td>Spam</td>
                                        <td>2025-12-24</td>
                                        <td><span className="badge bg-warning">Pending</span></td>
                                        <td>
                                            <button className="btn btn-sm btn-outline-primary"><i className="bi bi-eye"></i></button>
                                            <button className="btn btn-sm btn-outline-success"><i className="bi bi-check-lg"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#REP002</td>
                                        <td>jane.smith@company.com</td>
                                        <td>User Profile #789</td>
                                        <td>Fraud</td>
                                        <td>2025-12-23</td>
                                        <td><span className="badge bg-success">Resolved</span></td>
                                        <td>
                                            <button className="btn btn-sm btn-outline-primary"><i className="bi bi-eye"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- Complaints Tab --> */}
            <div className="tab-pane fade" id="complaints" role="tabpanel">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="mb-0"><i className="bi bi-chat-square-dots"></i> User Complaints</h6>
                        <div>
                            <select className="form-select form-select-sm d-inline-block w-auto">
                                <option>Filter Priority</option>
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                                <option>Critical</option>
                            </select>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table id="complaintsTable" className="table table-hover mb-0">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>User</th>
                                        <th>Subject</th>
                                        <th>Priority</th>
                                        <th>Created</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>#CMP001</td>
                                        <td>user123</td>
                                        <td>Payment Issue</td>
                                        <td><span className="badge bg-danger">Critical</span></td>
                                        <td>2025-12-25</td>
                                        <td><span className="badge bg-warning">Open</span></td>
                                        <td>
                                            <button className="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#complaintModal"><i className="bi bi-eye"></i></button>
                                            <button className="btn btn-sm btn-outline-success"><i className="bi bi-check-lg"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#CMP002</td>
                                        <td>devuser456</td>
                                        <td>Job not visible</td>
                                        <td><span className="badge bg-warning">High</span></td>
                                        <td>2025-12-22</td>
                                        <td><span className="badge bg-info">In Progress</span></td>
                                        <td>
                                            <button className="btn btn-sm btn-outline-primary"><i className="bi bi-eye"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </>
  );
};

const StatCard = ({ title, value, danger }) => (
  <div className="col-md-3">
    <div className="card stats-card shadow-sm">
      <div className="card-body">
        <div className="small text-muted text-uppercase">{title}</div>
        <div className={`h5 ${danger ? "text-danger" : ""}`}>
          {value || 0}
        </div>
      </div>
    </div>
  </div>
);


export default ApprovalsKYC;
